import { provideRouterStore, routerReducer } from '@ngrx/router-store'

import { MergedRouterStateSerializer } from './route-serializer'
import { ROUTER_FACADE, RouterFacade } from './router.facade'
import { routerFeatureKey } from './router.state'

export * from './router.facade'

export const ROUTER_FEATURE_REDUCER = { [routerFeatureKey]: routerReducer }
export const ROUTER_FEATURE_PROVIDERS = [
  [
    { provide: ROUTER_FACADE, useClass: RouterFacade },
    provideRouterStore({ stateKey: routerFeatureKey, serializer: MergedRouterStateSerializer }),
  ],
]
export const ROUTER_FEATURE_EFFECTS = []
